/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateSectionsControllerRemoveMutationResponse, TemplateSectionsControllerRemovePathParams, TemplateSectionsControllerRemove401, TemplateSectionsControllerRemove403, TemplateSectionsControllerRemove404 } from "../../models/checklistsController/TemplateSectionsControllerRemove";

function getTemplateSectionsControllerRemoveUrl(id: TemplateSectionsControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/checklist-template-sections/${id}` as const }  
  return res
}

/**
 * @summary Soft delete a checklist template section and cascade soft-delete its questions, sub-questions, and prompts
 * {@link /api/v1/checklist-template-sections/:id}
 */
export async function templateSectionsControllerRemove(id: TemplateSectionsControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplateSectionsControllerRemoveMutationResponse, ResponseErrorConfig<TemplateSectionsControllerRemove401 | TemplateSectionsControllerRemove403 | TemplateSectionsControllerRemove404>, unknown>({ method : "DELETE", url : getTemplateSectionsControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}